export const getItemCurrency = (item: string) => {
  if (item === 'RUB') {
    return '₽'
  }

  if (item === 'BYN') {
    return 'Br'
  }

  if (item === 'EUR') {
    return '€'
  }

  if (item === 'USD') {
    return '$'
  }

  return ''
}

export const getAmount = (sum: string | number | null | undefined) => {
  // Проверяем на null или undefined
  if (sum === null || sum === undefined) {
    return '0'
  }

  // Преобразуем строку в число, если передана строка
  const numericSum = typeof sum === 'string' ? parseFloat(sum) : sum

  // Проверяем, что получили валидное число
  if (isNaN(numericSum) || numericSum === null || numericSum === undefined) {
    return '0'
  }

  return numericSum.toLocaleString('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

/** Остаток по договору: сумма договора минус оплаченные счета */
export const getContractRemainingAmount = (
  amount: string | number | null | undefined,
  paidInvoices: string | number | null | undefined
): number => {
  const total =
    typeof amount === 'string' ? parseFloat(amount) : Number(amount ?? 0)
  const paid =
    typeof paidInvoices === 'string'
      ? parseFloat(paidInvoices)
      : Number(paidInvoices ?? 0)

  if (isNaN(total) || isNaN(paid)) return 0
  return total - paid
}
